import styled from "styled-components"
import { ButtonGroup } from "../../../../../../../_webui/layout/components/Button/Group"

const StyledButtonGroup = styled(ButtonGroup)`
  margin-top: 15px;
`

export const Styled = { StyledButtonGroup }
